import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  GET_EMPLOYEE,
  DELETE_EMPLOYEE,
  UPDATE_EMPLOYEE,
  ADD_NEW_EMPLOYEE,
  GET_EMPLOYEE_ONE,
} from "./actionType";

import {
  getEmployeeSuccess,
  getEmployeeFail,
  deleteEmployeeSuccess,
  deleteEmployeeFail,
  updateEmployeeSuccess,
  updateEmployeeFail,
  addEmployeeSuccess,
  addEmployeeFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveEmployeeApi,
  getEmployeeApi,
  updateEmployeeApi,
  deleteEmployeeApi,
  addNewEmployeeApi,
  getOneEmployeeApi,
} from "../../helpers/backend_helper";

function* getEmployee({ payload: employee }) {
  try {
    const response = yield call(getEmployeeApi, employee);
    yield put(getEmployeeSuccess(GET_EMPLOYEE, response.data));
  } catch (error) {
    yield put(getEmployeeFail(GET_EMPLOYEE, error));
  }
}

function* getEmployeeOne({ payload: id }) {
  try {
    const response = yield call(getOneEmployeeApi, id);
    yield put(getEmployeeSuccess(GET_EMPLOYEE_ONE, response.data));
  } catch (error) {
    yield put(getEmployeeFail(GET_EMPLOYEE_ONE, error));
  }
}

function* onUpdateEmployee({ payload: employee }) {
  try {
    if (employee.setApprove) {
      const response = yield call(approveEmployeeApi, employee);
      yield put(updateEmployeeSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    } else {
      const response = yield call(updateEmployeeApi, employee);
      yield put(updateEmployeeSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateEmployeeFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteEmployee({ payload: employee }) {
  try {
    const response = yield call(deleteEmployeeApi, employee);
    yield put(deleteEmployeeSuccess({ employee, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteEmployeeFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewEmployee({ payload: employee }) {
  try {
    const response = yield call(addNewEmployeeApi, employee);
    yield put(addEmployeeSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addEmployeeFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

export function* watchGetEmployee() {
  yield takeEvery(GET_EMPLOYEE, getEmployee);
}

export function* watchGetEmployeeOne() {
  yield takeEvery(GET_EMPLOYEE_ONE, getEmployeeOne);
}

export function* watchUpdateEmployee() {
  yield takeEvery(UPDATE_EMPLOYEE, onUpdateEmployee);
}

export function* watchDeleteEmployee() {
  yield takeEvery(DELETE_EMPLOYEE, onDeleteEmployee);
}

export function* watchAddNewEmployee() {
  yield takeEvery(ADD_NEW_EMPLOYEE, onAddNewEmployee);
}

function* employeeSaga() {
  yield all([
    fork(watchGetEmployee),
    fork(watchGetEmployeeOne),
    fork(watchDeleteEmployee),
    fork(watchUpdateEmployee),
    fork(watchAddNewEmployee),
  ]);
}

export default employeeSaga;
